import { Edit } from "react-admin";
import { CardDesignForm } from "./Form";

export function CardDesignEdit() {
  return (
    <Edit mutationMode="pessimistic" redirect="list">
      <CardDesignForm />
    </Edit>
  );
}
